/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Self, Optional, ChangeDetectorRef } from '@angular/core';
import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';
import { validatorHelper } from 'src/app/app-data/validators/validator-helpers';
import ticketValidator from '@touchplan/config/lib/ticket-validators.json';

@Component({
	selector: 'ticket-crew',
	templateUrl: './ticket-crew.component.html',
	styleUrls: ['./ticket-crew.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketCrewComponent extends TicketEditBaseComponent {
	public internalField: UntypedFormControl = new UntypedFormControl(null, validatorHelper('liveCrewSize'));
	public validationData = ticketValidator;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val: number) => {
			this.onChange(val);
		});
	}
}
